import { VStack, HStack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const AboutHoverInvestorsDesktop: React.FC = () => (
  <VStack
    spacing="75px"
    my={800}
    py={100}
    display={{ base: 'none', tablet: 'flex' }}
  >
    <HStack alignItems="center" spacing={{ tablet: '72px', desktop: 800 }}>
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={192}
        height={45}
        src="../../../assets/images/travelers_vector_logo.png"
        alt="investors travelers"
        style={{ marginBottom: '20px' }}
      />
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={130}
        height={47}
        src="../../../assets/images/menlo_ventures_logo.png"
        alt="menlo ventures"
      />
      <StaticImage
        placeholder="blurred"
        width={54}
        height={33}
        src="../../../assets/images/vc_logos.png"
        alt="vc"
      />
    </HStack>
    <HStack alignItems="center" spacing={900}>
      <StaticImage
        placeholder="blurred"
        width={260}
        height={22}
        src="../../../assets/images/state_farm_ventures_logo.png"
        alt="state farm"
      />
      <StaticImage
        placeholder="blurred"
        width={160}
        height={60}
        src="../../../assets/images/nationwide_seeklogo.png"
        alt="nation wide"
      />
    </HStack>
  </VStack>
);

export default AboutHoverInvestorsDesktop;
